const CreatorsTeam = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-sky-blue/10 to-bobo-green/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teedee-blue mb-4">
            Meet the Creator's Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The passionate individuals who brought Bobo & Teedee® to life
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Team Photo */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <img
                src="/img/bobo-and-teedee-team.png?w=600&h=400&fit=crop"
                alt="The creative team behind Bobo & Teedee® working together"
                className="w-full h-80 object-cover rounded-2xl shadow-xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teedee-blue/20 to-transparent rounded-2xl"></div>
            </div>
          </div>

          {/* Team Information */}
          <div className="order-1 lg:order-2 space-y-6">
            <div>
              <h3 className="text-2xl font-bold text-bobo-green mb-3">
                Our Creative Vision
              </h3>
              <p className="text-gray-600 mb-4">
                Our diverse team brings together educators, animators, writers,
                voice actors, and cultural consultants, all united by a shared
                passion for creating meaningful content that celebrates Cayman
                Islands heritage while teaching universal values.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-brand-purple mb-3">
                Local Expertise
              </h3>
              <p className="text-gray-600 mb-4">
                Every member of our team either calls the Cayman Islands home or
                has deep connections to our island community. This ensures that
                every story, every character, and every lesson authentically
                reflects the warmth, wisdom, and wonder of Cayman culture.
              </p>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-golden-orange mb-3">
                Educational Excellence
              </h3>
              <p className="text-gray-600">
                With backgrounds in early childhood education, child psychology,
                and curriculum development, our team creates content that's not
                just entertaining, but educationally sound and developmentally
                appropriate for young minds.
              </p>
            </div>

            <div className="pt-4">
              <div className="flex flex-wrap gap-3">
                <span className="px-4 py-2 bg-teedee-blue/10 text-teedee-blue rounded-full text-sm font-medium">
                  Animation
                </span>
                <span className="px-4 py-2 bg-bobo-green/10 text-bobo-green rounded-full text-sm font-medium">
                  Education
                </span>
                <span className="px-4 py-2 bg-brand-purple/10 text-brand-purple rounded-full text-sm font-medium">
                  Storytelling
                </span>
                <span className="px-4 py-2 bg-golden-orange/10 text-golden-orange rounded-full text-sm font-medium">
                  Voice Acting
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreatorsTeam;
